import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'content-info',
})

export default class ContentInfoComponent extends Vue {


    // --------------------------------------------------------
    // Properties

    @Prop()
    private contentList: any;

    @Prop()
    private productData: any;

    private publisherList: any = [];

    private activePublisher: any = null;

    private searchTerms: string = '';

    @Watch('contentList')
    private watchContentList() {
        this.loadProductDetails();
    }

    @Watch('productData')
    private onWatchContent() {
        this.activePublisher = this.productData;
    }

    // --------------------------------------------------------
    // Hooks

    private created() {
        this.loadProductDetails();
    }

    private activated() {
        this.activePublisher = this.productData;
    }

    // --------------------------------------------------------
    // Actions

    private onSelectPublisher(publisher: any) {
        this.activePublisher = publisher === this.activePublisher ? null : publisher;
        this.$emit('onSelectProduct', this.activePublisher);
    }

    private onSearchProduct() {
        const searchTerms = this.searchTerms;
        const contentList = this.contentList.subscribedTools || [];
        const publisherList = contentList.filter(
            (item: any) => (item.name.toLowerCase()).startsWith(searchTerms.toLowerCase()));
        this.publisherList = publisherList;
    }

    // --------------------------------------------------------
    // Methods

    private loadProductDetails() {
        const contentList = this.contentList.subscribedTools || [];
        this.publisherList = contentList.filter((item: any) => item.status === 'active');
    }


}
